const setOutline = target => {
  if (target.matches('label')) {
    const founder = target.closest('.ListStep2')
    const lastActive = founder.querySelector('.OutlinedItemActive')
    if (lastActive) {
      lastActive.classList.remove('OutlinedItemActive')
    }
    const parentRow = target.closest('.ListStep2Row')
    parentRow.classList.add('OutlinedItemActive', '-Rounded')
  }
}

export default {
  install(Vue) {
    Vue.directive('outline-resolver', {
      mounted: function (el) {
        console.log()
        el._outlineCallback = () => setOutline(el)
        el.addEventListener('click', el._outlineCallback)
      },
      unmounted: function (el) {
        el.removeEventListener('click', el._outlineCallback)
      }
    })
  }
}
